<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Admins</p>
                  <router-link :to="`/releases`">
                    <div class="dashboard-counts">{{ totalCounts.admins }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Blog Pages</p>
                  <router-link :to="`/blogs`">
                    <div class="dashboard-counts">{{ totalCounts.blogs }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">YouTube Music</p>
                  <router-link :to="`/youtube-music`">
                    <div class="dashboard-counts">{{ totalCounts.youtube }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Homepage Banners</p>
                  <router-link :to="`/homepage-banners`">
                    <div class="dashboard-counts">{{ totalCounts.homepageBanners }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Total Contact Queries</p>
                  <router-link :to="`/queries`">
                    <div class="dashboard-counts">{{ totalCounts.totalQueries }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Contact Queries in Last 24H</p>
                  <router-link :to="`/queries`">
                    <div class="dashboard-counts">{{ totalCounts.queriesLast24H }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Total Newsletter Subscriptions</p>
                  <router-link :to="`/newsletters`">
                    <div class="dashboard-counts">{{ totalCounts.totalNewsletter }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Newsletters in Last 24H</p>
                  <router-link :to="`/newsletters`">
                    <div class="dashboard-counts">{{ totalCounts.newsletterSubscriptionsLast24H }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      totalCounts: {
        'admins': '...',
        'blogs': '...',
        'youtube': '...',
        'homepageBanners': '...',
        'totalQueries': '...',
        'queriesLast24H': '...',
        'totalNewsletter': '...',
        'newsletterSubscriptionsLast24H': '...'
      }
    }
  },
  mounted () {
    this.fetchDashboardCounts()
  },
  methods: {
    fetchDashboardCounts () {
      this.$store.dispatch('fetchDashboardCounts')
        .then((result) => {
          console.log(result)
          this.totalCounts = result.data
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}
</script>

<style scoped>
.main-loader {
    height: calc(59vh - 73px);
}
.account-activity-chart-container {
  flex-grow: 1;
  min-height: 0;
}
.account-activity-chart-container > div {
  position: relative;
  height: 100%;
}
.card-body {
  padding: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue